export default __webpack_public_path__ + "f4f93856730733912b1e06ad64c0baf7.woff";